// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","modal":"modal_modal__prloO","close":"modal_close__PaoHK"};